<template>
  <div class="animated fadeIn mt-2">
    <hr />
    <b-row>
      <b-col md="2" class="pt-2">Sample ID</b-col>
      <b-col>
        <b-form-group :horizontal="true">
          <b-form-input
            type="text"
            v-model="identifier"
            placeholder="Sample Name"
            invalid-feedback="Required"
            :state="!$v.identifier.$invalid"
          />
        </b-form-group>
      </b-col>
      <b-col v-if="bore_hole.samples.length > 1" md="1" class="pl-0">
        <b-button
          variant="danger"
          block
          @click="removeSample(boreHoleId, sampleId)"
        >
          <i class="fal fa-trash" />
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="2" class="pt-2">Field Texture</b-col>
      <b-col>
        <b-form-group
          invalid-feedback="Required"
          :state="!$v.field_texture.$invalid"
          :horizontal="true"
        >
          <add-on-select
            :selectedItem="field_texture"
            :customPlaceholder="'Select Sample Field Texture'"
            :options="textureOptions"
            @change="handleSelect"
          />
        </b-form-group>
      </b-col>
      <b-col md="2" class="pt-2">Soil Horizon</b-col>
      <b-col>
        <b-form-group
          invalid-feedback="Required"
          :state="!$v.soil_horizon.$invalid"
          :horizontal="true"
        >
          <add-on-select
            :selectedItem="soil_horizon"
            :customPlaceholder="'Select Sample Soil Horizon'"
            :options="horizonOptions"
            @change="handleSelect"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col md="2" class="pt-2">Depth</b-col>
      <b-col>
        <b-input-group append='"'>
          <b-form-input
            type="number"
            v-model.number="depth_start"
            placeholder="Start"
            invalid-feedback="Required"
            :state="!$v.depth_start.$invalid"
          />
        </b-input-group>
      </b-col>
      <b-col>
        <b-input-group append='"'>
          <b-form-input
            type="number"
            v-model.number="depth_end"
            placeholder="End"
            invalid-feedback="Required"
            :state="!$v.depth_end.$invalid"
          />
        </b-input-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import AddOnSelect from "../../misc/AddOnSelect";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate/src";
import { required } from "vuelidate/lib/validators";

export default {
  name: "ProjectIrrigationBoreHole",
  components: { AddOnSelect },
  mixins: [validationMixin, ToastNotifications],
  props: {
    submissionId: {
      type: String,
      default: "",
    },
    boreHoleId: {
      type: String,
      default: "",
    },
    sampleId: {
      type: String,
      default: "",
    },
    textureOptions: {
      type: Object,
      default: () => ({}),
    },
    horizonOptions: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission",
    }),
    currentSubmission() {
      return this.submission(this.submissionId);
    },
    bore_holes() {
      return this.currentSubmission.bore_holes;
    },
    bore_hole() {
      return this.currentSubmission.bore_holes.find(
        (hole) => hole.bore_hole_id === this.boreHoleId
      );
    },
    sample() {
      return this.bore_hole.samples.find(
        (sample) => sample.test_package_sample_id === this.sampleId
      );
    },
    field_texture() {
      return this.sample.field_texture;
    },
    soil_horizon() {
      return this.sample.soil_horizon;
    },
    identifier: {
      get() {
        return this.sample.identifier;
      },
      set(value) {
        this.handleSampleUpdate({ value, field: "identifier" });
      },
    },
    depth_start: {
      get() {
        return this.sample.depth_start;
      },
      set(value) {
        this.handleSampleUpdate({ value, field: "depth_start" });
      },
    },
    depth_end: {
      get() {
        return this.sample.depth_end;
      },
      set(value) {
        this.handleSampleUpdate({ value, field: "depth_end" });
      },
    },
  },

  validations: {
    identifier: { required },
    field_texture: { required },
    soil_horizon: { required },
    depth_start: { required },
    depth_end: { required },
  },

  methods: {
    ...mapActions(["UPDATE_SUBMISSION"]),

    handleSampleUpdate({ value, field }) {
      this.sample[field] = value;
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value: this.bore_holes,
        name: "bore_holes",
      });
    },

    handleSelect({ selected, field }) {
      this.handleSampleUpdate({ value: selected, field });
    },

    removeSample(bHId, sId) {
      const updatedSamples = this.bore_holes.map((bore_hole) => {
        if (bore_hole.bore_hole_id === bHId) {
          const newSamples = bore_hole.samples.filter(
            (sample) => sample.test_package_sample_id !== sId
          );
          bore_hole.samples = [...newSamples];
        }
        return bore_hole;
      });
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value: updatedSamples,
        name: "bore_holes",
      });
    },
  },
};
</script>
